import React, { useEffect, useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { ROUTE_PATHS } from '@constants';
import { useStore } from '@hooks';
import { Loader } from '@ui';
import { observer } from 'mobx-react';
import AuthLayout from '../../layouts/AuthLayout';
import { StyledText } from './styled';

const TransferOwnership = observer(() => {
    const store = useStore();
    const { handleConfirmOwnership } = store.accountsStore;

    const [loading, setLoading] = useState(true);

    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    useEffect(() => {
        (async () => {
            if (token) {
                await handleConfirmOwnership(token);
                setLoading(false);
            }
        })();
    }, []);

    if (!token) {
        return (
            <AuthLayout
                description={
                    <StyledText>
                        It seems there might be an issue with the invitation link you used. Please request a new
                        invitation from the store owner.
                    </StyledText>
                }
                leftCol=''
                title='Transfer Ownership'
            />
        );
    }

    if (loading) {
        return <Loader />;
    }

    return <Navigate to={ROUTE_PATHS.TEAM_MANAGEMENT} replace />;
});

export default TransferOwnership;
